import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";

// Internal components
import Title from "components/Title";
import Btn from "components/Btn";
import Duk from "components/Duk";
import Signaturer from "components/Signaturer";
import Lommetorkle from "components/Lommetorkle";
import LanguagePicker from "components/LanguagePicker";
import Meta from "components/Meta";

// Contexts
import { DataContext } from "contexts/Data";

// External components
import { RiDragMove2Fill, RiDragDropLine } from "react-icons/ri";
import { GiMouse, GiArchiveResearch } from "react-icons/gi";
import SVG from "react-inlinesvg";
// import PinchToZoom from "react-pinch-and-zoom";

const Inspirasjon = () => {
    const { pathname } = useLocation();
    const { data, language, screenWidth, setLanguage } =
        useContext(DataContext);
    useEffect(() => {
        if (pathname === "/background") {
            setLanguage("en");
        } else if (pathname === "/bakgrunn") {
            setLanguage("no");
        }
    }, [pathname]);
    useEffect(() => {
        if (screenWidth > 900) {
            var scale = 1,
                panning = false,
                pointX = 0,
                pointY = 0,
                start = {
                    x: 0,
                    y: 0,
                },
                zoom = document.getElementById("zoom-inspirasjon");

            function setTransform() {
                zoom.style.transform =
                    "translate(" +
                    pointX +
                    "px, " +
                    pointY +
                    "px) scale(" +
                    scale +
                    ")";
            }

            zoom.onmousedown = function (e) {
                zoom.style.transition = "none";
                e.preventDefault();
                start = { x: e.clientX - pointX, y: e.clientY - pointY };
                panning = true;
            };

            zoom.onmouseup = function (e) {
                zoom.style.transition = "none";
                panning = false;
            };

            zoom.onmousemove = function (e) {
                zoom.style.transition = "none";
                e.preventDefault();
                if (!panning) {
                    return;
                }
                pointX = e.clientX - start.x;
                pointY = e.clientY - start.y;
                setTransform();
            };

            zoom.onwheel = function (e) {
                zoom.style.transition =
                    "transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1)";
                e.preventDefault();
                var xs = (e.clientX - pointX) / scale,
                    ys = (e.clientY - pointY) / scale,
                    delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                delta > 0 ? (scale *= 1.02) : (scale /= 1.02);
                pointX = e.clientX - xs * scale;
                pointY = e.clientY - ys * scale;

                setTransform();
            };
            zoom.ondblclick = function (e) {
                e.preventDefault();
                var xs = (e.clientX - pointX) / scale,
                    ys = (e.clientY - pointY) / scale;
                scale *= 2;
                pointX = e.clientX - xs * scale;
                pointY = e.clientY - ys * scale;
                zoom.style.transition =
                    "transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)";
                console.log(pointX, pointY);
                setTransform();
            };
        }
    }, [screenWidth]);
    const [hideInstructions, setHideInstructions] = useState(false);
    return (
        <>
            <div
                className={`instructions ${
                    hideInstructions ? "instructions--hide" : ""
                }`}
                onClick={() => setHideInstructions(true)}
            >
                <div>
                    {screenWidth > 900 && (
                        <>
                            <p>
                                <RiDragMove2Fill size="3rem" />
                                {language === "no"
                                    ? "Hold inne og dra for å navigere"
                                    : ""}
                                {language === "en"
                                    ? "Press and drag the mouse to navigate"
                                    : ""}
                            </p>
                            <p>
                                <GiMouse size="3rem" />
                                {language === "no"
                                    ? "Rull musehjulet for å zoome"
                                    : ""}
                                {language === "en" ? "Scroll to zoom" : ""}
                            </p>
                            <p>
                                <GiArchiveResearch size="3rem" />
                                {language === "no"
                                    ? "Ta musen over objektene for å se de ulike delene"
                                    : ""}
                                {language === "en"
                                    ? "Hover over the objects to reveal it's parts"
                                    : ""}
                            </p>
                        </>
                    )}
                    <p>
                        <RiDragDropLine size="3rem" />
                        {language === "no"
                            ? "Trykk på deler av objektene for å forstørre bildet"
                            : ""}
                        {language === "en"
                            ? "Click on the highlighted sections to open gallery view"
                            : ""}
                    </p>
                    <div className="instructions__close-btn">
                        <SVG
                            src={process.env.PUBLIC_URL + "/images/close.svg"}
                            width="3rem"
                        />
                    </div>
                    {/* <div className="btn--patch-vertical">Lukk</div> */}
                </div>
            </div>

            <Meta
                title={data.seo.inspirasjon.title || ""}
                description={data.seo.inspirasjon.description || ""}
                image={data.seo.inspirasjon.image || ""}
            />
            <LanguagePicker
                redirects={{
                    no: data.pages.inspirasjon.to.no,
                    en: data.pages.inspirasjon.to.en,
                }}
            />
            <section className="inspirasjon">
                {/* <div className="inspirasjon-modal">
                    <div className="inspirasjon-modal__box"></div>
                </div> */}
                <div className="container inspirasjon-header inspirasjon__container">
                    <Title
                        title={data.pages.inspirasjon.content.title[language]}
                    />
                </div>
                {screenWidth > 900 ? (
                    <div className="zoom_outer">
                        <div id="zoom-inspirasjon">
                            <div className="wrapper-position inspirasjon-grid-wrapper">
                                <div className="inspirasjon-grid">
                                    <Duk />
                                    <Lommetorkle />
                                    <Signaturer />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="inspirasjon-grid">
                        <Duk />
                        <Lommetorkle />
                        <Signaturer />
                    </div>
                )}
                <Btn
                    className="btn--patch-vertical next-btn"
                    to={data.pages.galleri.to[language]}
                >
                    {data.nextButton[language]}
                </Btn>
            </section>
        </>
    );
};

export default Inspirasjon;
